import store from "@/store";
const path = require("path");

class InsertImage {
  constructor(editor) {
    this.editor = editor;
  }

  filePayload(file) {
    let extension = path.extname(file.name);
    let payload = {
      file: file,
      legenda: path.basename(file.name, extension),
      mime_type: file.type,
      extra_data: {
        name: path.basename(file.name, extension),
        basename: path.basename(file.name),
        extension: extension,
        lastModified: file.lastModified,
        size: file.size,
        type: file.type,
      },
      categoria: null,
      categoria_arquivos: [],
      descricao: null,
      estrutura_id: null,
      sobrescrever: false,
      tags: [],
      url: "",
      editor_image: true,
    };
    return payload;
  }

  async upload() {
    let fileObj = null;

    await this.editor.file.then(async (file) => {
      fileObj = await store.dispatch(
        "files/ActionStore",
        this.filePayload(file)
      );
    });

    return fileObj
      ? {
          urls: {
            default: fileObj.url,
          },
        }
      : null;
    //return this.editor.file;
  }

  _initRequest() {}
  abort() {}
}

const UploadAdapterPlugin = (editor) => {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return new InsertImage(loader);
  };
};

export default UploadAdapterPlugin;
